import { Router, Route, IndexRoute, browserHistory } from 'react-router';
import React from "react";

import AccountApp from "./containers/AccountApp";

//Redux Smart
import Page from "./components/Page";
import OrderPage from "./containers/OrderPage";
import Account from "./components/Account";

//Redux Dumb
import error404 from "./components/404";

export default (
  <Route name="app" path="/" component={AccountApp}>
    <Route path="home" component={Account} />

    <Route path="/tour/:param_id/order" component={OrderPage} />
    <Route path="/order/:order_id" component={OrderPage} />
    <Route path="/404" component={error404}/>
    <Route path="/account" component={Account}/>

      <Route name="page" path="/:param_id" component={Page} />
  </Route>
);



// WEBPACK FOOTER //
// ./src/common/account_routes.js